<div class="flex-container">
  <div class="flex-item">
    <img
      class="logo"
      src="../../../../../assets/WhatNow-logo-version1_rev_2.jpg"
    />
  </div>
  <div class="change-bg flex-item">
    <div >
        <h3>Welcome back,</h3>
        <h3>Please login to your account.</h3>
        <div class="example-container">
          <form [formGroup]="loginForm" (ngSubmit)="handleLogin()">
            <mat-form-field appearance="fill">
              <mat-label>Phone/Email</mat-label>
              <input matInput formControlName="username" placeholder="Enter, email/phone here." required>
            </mat-form-field>
            <br>
            <mat-form-field appearance="fill">
                <mat-label>Enter your password</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" required>
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
            <br>
            <button mat-raised-button color="primary" [disabled]="!loginForm.valid">LogIn</button>
            <br><br>
          </form>
         <!-- <h5>Don't have an account <span style="text-decoration: underline; cursor: pointer;" (click)=swichBetweenLoginSignup()>Sign Up.</span></h5> -->
        </div>
    </div>
    
    <!-- <ng-template #signup>
    <div class="example-container">
      <h3>Welcome,</h3>
      <h3>Please enter the details to Sign up.</h3>
      <form [formGroup]="signupForm" (ngSubmit)="handleSignUp()">
        <mat-form-field appearance="fill">
          <mat-label >First Name</mat-label>
          <input matInput formControlName="firstName" required>
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" required>
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" required>
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" required>
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
          <mat-label>Password</mat-label>
          <input matInput formControlName="passwordCreate" required>
        </mat-form-field>
        <br>
        <button mat-raised-button color="primary" [disabled]="!signupForm.valid">SignUp</button>
        <br><br>
      </form>
      <h5>Already have an account <span style="text-decoration: underline; cursor: pointer;" (click)=swichBetweenLoginSignup()>Sign In.</span></h5>
    </div>
  </ng-template> -->

  </div>
</div>

